import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import Image from './Image';

describe('Render', () => {
  it('should render component', () => {
    const { container } = render(<Image alt="" />);
    expect(container.querySelector('img')).toBeInTheDocument();
  });
});
